import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { AdminDashboard } from "./AdminDashboard";
export var AdminPage = function () {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return React.createElement(AdminDashboard, null); } })));
};
